<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-info-circle', fontSet: 'fad'}"
	[headerText]="data?.title"
>
	<div dialogContent>
		<div class="bottom">
			<div class="text">
				{{ data.description }}
			</div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'ok'})"
			[color]="'primary'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText.toUpperCase()"
		/>
	</ng-container>
</sim-basic-material-dialog>
